module.exports = __webpack_public_path__ + "media/images/amenities_icons/locker-96f143bfc1d2f1a28697769ded9363c7.svg";